export default __webpack_public_path__ + "274fb8bf156d41ad9890811ac54d4f66.jpg";